/*
 * @Author: your name
 * @Date: 2021-01-31 11:26:20
 * @LastEditTime: 2021-01-31 11:57:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /marmot_design_ui/src/components/upload/img-upload/img.upload.tsx
 */
import React, { Component } from "react";
import FilesUpload, { iProps } from "./index";
interface fileUploadProps extends iProps {
  value?: any[];
}
export default class FileUpload extends Component<fileUploadProps> {
  render() {
    let { props = {} } = this;
    return <FilesUpload fileList={this.props.value} {...props}></FilesUpload>;
  }
}
